import React, { useCallback } from 'react'
import { useParams } from 'react-router'

import { landAxios } from '@Root/utils/landAxios'
import VAC_AlarmPopup from '@Components/VAC/alarm/VAC_AlarmPopup'
import usePopup from '@Hooks/popup/usePopup'
import useOwnerArticle from '@Hooks/alarm/useOwnerArticle'

const AlarmConfirmPopup: React.FC = () => {
  const { popup, changeInit } = usePopup()
  const { ownerArticle, updateIsArticleConfirm } = useOwnerArticle()
  const { articleNo: encryptedArticleNo } = useParams<{ articleNo: string }>()

  const handleClickConfirm = useCallback(
    (evt: React.SyntheticEvent) => {
      evt.preventDefault()
      evt.stopPropagation()
      updateIsArticleConfirm(encryptedArticleNo)
      changeInit()
    },
    [ownerArticle],
  )

  const popupProps = {
    popupList: {
      [popup.key]: { ...popup, confirmText: '확인', handleClickConfirm },
    },
  }

  return (
    <>
      <VAC_AlarmPopup popupList={popupProps.popupList} isHidden={false} />
    </>
  )
}

export default AlarmConfirmPopup
